import {isString} from 'lodash'

const FONT_SIZE_REGEX = /(^|[^-\w])((\d+(?:\.\d+)?)(?:px|spx))/

const extractFontSizeFromString = (fontString: string) =>
    parseFloat((FONT_SIZE_REGEX.exec(fontString) ?? ['0', '0', '0', '0'])[3])

export const extractFontSizeUnitFromString = (fontString: string) => {
    const match = FONT_SIZE_REGEX.exec(fontString)
    if (!match) return ''
    const numberPart = match[3]
    return match[0].slice(numberPart.length)
}

const extractFontSize = (fontStyleEntryValue: string): number | undefined => {
    if (isString(fontStyleEntryValue)) {
        return extractFontSizeFromString(fontStyleEntryValue)
    }
    return undefined
}

export interface FontSizeMappingHeuristicEntry {
    minSourceFontSize: number
    maxSourceFontSize?: number
    targetFontSize?: number
    scaleProportionally?: boolean
}

export const FONT_SIZE_CLASSES_RULES: FontSizeMappingHeuristicEntry[] = [
    {
        minSourceFontSize: 0,
        maxSourceFontSize: 14
    },
    {
        minSourceFontSize: 14,
        maxSourceFontSize: 19,
        targetFontSize: 16
    },
    {
        minSourceFontSize: 19,
        maxSourceFontSize: 22,
        targetFontSize: 18
    },
    {
        minSourceFontSize: 22,
        maxSourceFontSize: 26,
        targetFontSize: 20
    },
    {
        minSourceFontSize: 26,
        maxSourceFontSize: 30,
        targetFontSize: 22
    },
    {
        minSourceFontSize: 30,
        maxSourceFontSize: 38,
        targetFontSize: 24
    },
    {
        minSourceFontSize: 38,
        maxSourceFontSize: 46,
        targetFontSize: 26
    },
    {
        minSourceFontSize: 46,
        maxSourceFontSize: 54,
        targetFontSize: 28
    },
    {
        minSourceFontSize: 54,
        maxSourceFontSize: 70,
        targetFontSize: 30
    },
    {
        minSourceFontSize: 70,
        maxSourceFontSize: 78,
        targetFontSize: 32
    },
    {
        minSourceFontSize: 78,
        maxSourceFontSize: 86,
        targetFontSize: 34
    },
    {
        minSourceFontSize: 86,
        maxSourceFontSize: 94,
        targetFontSize: 36
    },
    {
        minSourceFontSize: 95,
        maxSourceFontSize: 102,
        targetFontSize: 38
    },
    {
        minSourceFontSize: 102,
        scaleProportionally: true
    }
]

const isFontInRange = (fontStyleEntryItem: string, minValue: number, maxValue?: number) => {
    const size = extractFontSize(fontStyleEntryItem)
    if (!size) return false
    if (size < minValue) return false
    return !(maxValue && size > maxValue)
}

export const getMobileFontSize = (fontSizeString: string) => {
    const {targetFontSize} =
        FONT_SIZE_CLASSES_RULES.find(({minSourceFontSize, maxSourceFontSize}) =>
            isFontInRange(fontSizeString, minSourceFontSize, maxSourceFontSize)
        ) ?? {}

    return {
        targetFontSize: targetFontSize ?? extractFontSize(fontSizeString),
        unit: extractFontSizeUnitFromString(fontSizeString)
    }
}
